import React from 'react';
import styles from './Home.module.css'; // 1. Import the new CSS module

// Components
import CarouselFadeExample from "../Components/CarouselFadeExample";
import { AboutTeam } from '../Components/AboutTeam';
import Experties from "../Components/Experties/Experties";
import { Application } from '../Components/Application';
import { JoinUs } from '../Components/JoinUs';

export const Home = () => {
    return (
        // 2. Use the mainContainer class for the animated background
        <div className={styles.mainContainer}>
            {/* 3. Wrap content to ensure it's layered on top */}
            <div className={styles.contentWrapper}>
                <CarouselFadeExample />
                <Application />
                <AboutTeam />
                <Experties />
                <JoinUs />
            </div>
        </div>
    );
}